<template>
  <div id="tab2">
    <h1>Tab 2</h1>
    <p>Example tab menu 2 case is disabled.</p>
  </div>
</template>

<script>
export default {
  name: 'Tab2'
}
</script>